module.exports = __webpack_public_path__ + "img/icon_sb_shipping_18x13.f03752e.svg";